import React from 'react';
import { Checkbox } from '../../../components/ui/Checkbox';
import Icon from '../../../components/AppIcon';

const ApplianceSection = ({ 
  applianceConfig, 
  onApplianceConfigChange, 
  isCollapsed = false,
  onToggleCollapse 
}) => {
  const handleApplianceChange = (appliance, checked) => {
    onApplianceConfigChange({
      ...applianceConfig,
      [appliance]: checked
    });
  };

  const appliances = [
    { key: 'cooktop', label: 'Plaque de cuisson', icon: 'Flame' },
    { key: 'oven', label: 'Four', icon: 'Box' },
    { key: 'microwave', label: 'Micro-ondes', icon: 'Zap' },
    { key: 'dishwasher', label: 'Lave-vaisselle', icon: 'Droplets' },
    { key: 'washingMachine', label: 'Lave-linge', icon: 'RotateCcw' },
    { key: 'dryer', label: 'Sèche-linge', icon: 'Wind' },
    { key: 'refrigerator', label: 'Réfrigérateur', icon: 'Snowflake' },
    { key: 'freezer', label: 'Congélateur', icon: 'Snowflake' },
    { key: 'rangeHood', label: 'Hotte aspirante', icon: 'Fan' }
  ];

  return (
    <div className="bg-surface border border-border rounded-lg">
      <div 
        className="flex items-center justify-between p-4 cursor-pointer"
        onClick={onToggleCollapse}
      >
        <div className="flex items-center space-x-3">
          <div className="flex items-center justify-center w-8 h-8 bg-warning rounded-full">
            <Icon name="Zap" size={16} color="white" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-text-primary">Électroménager</h3>
            <p className="text-sm text-text-secondary">Sélection des appareils à intégrer</p>
          </div>
        </div>
        <Icon 
          name={isCollapsed ? "ChevronDown" : "ChevronUp"} 
          size={20} 
          className="text-text-secondary" 
        />
      </div>
      {!isCollapsed && (
        <div className="px-4 pb-4 border-t border-border">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 mt-4">
            {appliances?.map((appliance) => (
              <div key={appliance?.key} className="flex items-center space-x-3 p-3 bg-muted rounded-lg">
                <Icon name={appliance?.icon} size={18} className="text-text-secondary" />
                <Checkbox
                  label={appliance?.label}
                  checked={applianceConfig?.[appliance?.key] || false}
                  onChange={(e) => handleApplianceChange(appliance?.key, e?.target?.checked)}
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ApplianceSection;